<article class="box_default box_white" [ngClass]="{'with-overlay': actionStatus == STATUS_ERROR || actionStatus == STATUS_NOT_ALLOWED}">
  <core-layout-modal-feedback class="modal-feedback modal-feedback-set-pass" *ngIf="actionStatus == STATUS_ERROR || actionStatus == STATUS_NOT_ALLOWED"
    [type]="'fail'"
    [message]="'Error'"
    [text]="'The workflow name could NOT be updated. Please try again.<br/> If the error persists, please reach out to our support team through the Help Me button.'"
    [buttonText]="'OK'"
    (action)="onError($event)">
  </core-layout-modal-feedback>
  <header>
    <h3>EDIT WORKFLOW NAME</h3>
  </header>
  <div class="box_main" *ngIf="form != null">
    <form [formGroup]="form">
      <div class="box_item">
        <label class="box-label">NAME</label>
          <input type="text" placeholder="Write the new name." formControlName="name"/>
      </div>
      <div class="box_fieldset">
        <core-helpers-forms-button-white [text]="'Save'" [disabled]="form.invalid" (click)= "updateName()"></core-helpers-forms-button-white>
        <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel($event)"></core-helpers-forms-button>
      </div>
      <div [hidden]="actionStatus != STATUS_LOADING" class="workflow-editor-saving">
        <core-helpers-box-loading></core-helpers-box-loading>
      </div>
    </form>
  </div>
  
</article>
